import React from 'react';

import { observer } from 'mobx-react';

import classes from './AutomatedBillingPayment.module.scss';
import { EntityType } from '../../../../shared/constants/user-info/ENTITY_TYPES';
import { angularizeWithProviders } from '../../../../shared/providers';
import { ConnectStripeWidget } from '../../../containers/ConnectStripeWidget/ConnectStripeWidget';
import { FeeModuleWidget } from '../../../containers/FeeModuleWidget/FeeModuleWidget';
import { TaxWidget } from '../../../containers/TaxWidget/TaxWidget';
import { SubscriptionSettingsWidget } from '../../../containers/SubscriptionSettingsWidget/SubscriptionSettingsWidget';
import { NutritionSubscriptionsManagement } from '../../../containers/EntitySubscriptionsManagement/NutritionSubscriptionsManagement/NutritionSubscriptionsManagement';
import { FreeAccessWidget } from '../../../containers/FreeAccessWidget/FreeAccessWidget';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';

type AutomatedBillingPaymentProps = {
  entityId: number;
  isStripeConnected: boolean;
  entityType: EntityType;
};

const AutomatedBillingPayment = observer(
  ({ entityId, isStripeConnected, entityType }: AutomatedBillingPaymentProps) => {
    const { isEntity, isSuperAdmin } = loggedInUserDataStore;

    return (
      <>
        <div className={classes.row}>
          <div className={classes.column}>
            {isEntity && (
              <ConnectStripeWidget
                entityId={entityId}
                isStripeConnected={isStripeConnected}
              />
            )}
            {isSuperAdmin && (
              <FeeModuleWidget entityId={entityId} entityType={entityType} />
            )}
            <TaxWidget entityId={entityId} />
          </div>
          <SubscriptionSettingsWidget entityId={entityId} />
        </div>
        <NutritionSubscriptionsManagement entityId={entityId} />
        <FreeAccessWidget entityId={entityId} />
      </>
    );
  },
);

angularizeWithProviders(AutomatedBillingPayment, 'ngzAutomatedBillingPaymentTab', {
  entityId: '<',
  isStripeConnected: '<',
  entityType: '<',
});

export { AutomatedBillingPayment };
